import SpriteSymbol from "../../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.store/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrowDown",
  "use": "icon-arrowDown-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrowDown\">\n<path d=\"M6.3962 7.98532C6.19605 8.24532 5.80395 8.24532 5.6038 7.98532L3.15559 4.805C2.90249 4.47621 3.13687 4 3.55179 4L8.44821 4C8.86313 4 9.09751 4.47621 8.84441 4.805L6.3962 7.98532Z\" fill=\"#9D9D9D\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol